var map = {
	"./error-page.webp": 2411,
	"./maintenance.webp": 2412,
	"./miscellaneous-bg.webp": 2413,
	"./miscellaneous-mobile-bg.webp": 2414,
	"./restriction.webp": 2415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;